import { useTranslation } from "react-i18next";
import { ACCESS_CONTROL, ALARMS, CCTV, FIRE_PROTECTION, INSTALLATIONS, NETWORKS, toGallery } from "../../../slides";
import { ItemRenderer } from "../../Start/Start";
import ReactImageGallery from "react-image-gallery";
import "./Realizations.css";

const sections = [
  {
    title: "start.services.installations",
    id: "installations",
    items: toGallery(INSTALLATIONS)
  },
  {
    title: "start.services.alarms",
    id: "alarms",
    items: toGallery(ALARMS)
  },
  {
    title: "start.services.cctv",
    id: "cctv",
    items: toGallery(CCTV)
  },
  {
    title: "start.services.access_control",
    id: "access_control",
    items: toGallery(ACCESS_CONTROL)
  },
  {
    title: "start.services.fire_protection",
    id: "fire_protection",
    items: toGallery(FIRE_PROTECTION)
  },
  {
    title: "start.services.networks",
    id: "networks",
    items: toGallery(NETWORKS)
  }
];

interface Service {
  title: string,
  description: string,
  services: string[],
  uses: string
}

export function Realizations() {
  const { i18n } = useTranslation();

  const services: Service[] = i18n.t("services", { returnObjects: true });
  const combined = sections.map((s, i) => {
    return {
      ...(services[i]),
      ...s
    };
  })
  return <div className="Realizations">
    <div className='content'>
      {combined.map(s => {
        return <>
          <div id={s.id} className='section-title'>{i18n.t(s.title)}</div>
          <section>
            {s.description}
            <ul>
              {s.services.map(s => <li>{s}</li>)}
            </ul>
            {s.uses}
          </section>
          <ReactImageGallery
            items={s.items}
            infinite={true}
            showNav={true}
            showFullscreenButton={true}
            showPlayButton={true}
            showBullets={true}
            autoPlay={true}
            renderItem={(p) => <ItemRenderer {...p}></ItemRenderer>}
            additionalClass='custom-gallery'
          />
        </>
      })}
    </div>
  </div>;
}